import { List } from "immutable"

declare global {
  interface Window {
    grecaptcha:any
    dataLayer: any
    wp: {
      url: string
      api: string
      language: 'nl' | 'en' | 'de'
      is_user_logged_in: boolean,
      nonce: string,
      store: {
        [key: string]: any
      }
    }
    scrollTo(): void
    Optanon: any
    // MktoForms2?: any
  }
  
}

declare let grecaptcha: any
declare let recaptcha_sitekey: string
declare let should404: boolean 
export const sitename: string = 'ReumaNederland'


//default langauge
export const defaultLanguage: Locale = 'nl'

//supported languages
export type Locale = "en" | "nl" | string

//current languages for site
export const allLanguages: List<Locale> = List([
  'en', 'nl'
])